import axios, { AxiosResponse } from 'axios';
import { Ic1, Ic2Prehled, Ic3neprima, Ic3prima, Ic4, Ic5, Ic6 } from 'types/amlz';

import getLanguageObject from 'utils/getLanguageObject';

import { ISubjPravo } from './zadostPravo';

export const zalozitAmlzZadost = (isDLT?: boolean) => {
    return axios({
        method: 'PUT',
        url: isDLT ? '/AML/zadostpo' : '/AML/zadost'
    }).then(
        (
            resp: AxiosResponse<{
                idzadosti: number;
                datum: string;
                stav: string;
                uzivatel: string;
            }>
        ) => resp.data
    );
};

export const amlzC1get = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/c1`
    }).then((resp: AxiosResponse<Ic1>) => resp.data);
};

export const amlzC1send = (id: number, data: Ic1, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/AML/${id}/c1`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};

export const amlzC2osobyGet = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/osobyc2`
    }).then((resp: AxiosResponse<Ic2Prehled>) => resp.data);
};
export const amlzC2osobyPridat = (id: number) => {
    return axios({
        method: 'POST',
        url: `/AML/${id}/osobyc2/pridat`
    }).then((resp: AxiosResponse<{ id: number }>) => resp.data);
};
export const platebniInstrukcePDFapi = (id: number, language: string, idOsoby?: number) => {
    return axios({
        method: 'POST',
        url: idOsoby ? `/AMLodkaz/${id}/osobac2/${idOsoby}/pdfplatbadownload` : `/AMLpristup/${id}/pdfplatbadownload`,
        responseType: 'blob' // important
    }).then((resp: { status: number; data: any }) => {
        if (resp.status === 200) {
            // způsob, jak stažený dokument otevřít v browseru
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nav = window.navigator as any;
            // IE
            if (nav?.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(resp.data, `${getLanguageObject(language).PLATEBNI_INSTRUKCE}.pdf`);
            } else {
                const odp = resp.data;

                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: 'application/octetstream'
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = `${getLanguageObject(language).PLATEBNI_INSTRUKCE}.pdf`;
                link.href = uriContent;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};

export const amlzC2osobyDetailGet = (id: number | string, osobaId: number | string) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/osobyc2/${osobaId}`
    }).then((resp: AxiosResponse<ISubjPravo>) => resp.data);
};

export const amlzC2osobyDetailsend = (
    id: number | string,
    osobaId: number | string,
    data: ISubjPravo,
    type: 'PUT' | 'POST'
) => {
    return axios({
        method: type,
        url: `/AML/${id}/osobyc2/${osobaId}`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};
export const amlzC3primaGet = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/c3/prima`
    }).then((resp: AxiosResponse<Ic3prima>) => resp.data);
};

export const amlzC3primaSend = (id: number, data: Ic3prima, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/AML/${id}/c3/prima`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};
export const amlzC3neprimaGet = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/c3/neprima`
    }).then((resp: AxiosResponse<Ic3neprima>) => resp.data);
};

export const amlzC3neprimaSend = (id: number, data: Ic3neprima, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/AML/${id}/c3/neprima`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};
export const amlzC4Get = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/c4`
    }).then((resp: AxiosResponse<Ic4>) => resp.data);
};

export const amlzC4Send = (id: number, data: Ic4, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/AML/${id}/c4`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};
export const amlzC5Get = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/c5`
    }).then((resp: AxiosResponse<Ic5>) => resp.data);
};

export const amlzC5Send = (id: number, data: Ic5, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/AML/${id}/c5`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};
export const amlzC6Get = (id: number) => {
    return axios({
        method: 'GET',
        url: `/AML/${id}/c6`
    }).then((resp: AxiosResponse<Ic6>) => resp.data);
};

export const amlzC6Send = (id: number, data: Ic6, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/AML/${id}/c6`,
        data: data
    }).then((resp: { data: any }) => resp.data);
};

export const historiePDFdownloadApi = (id: number) => {
    return axios({
        method: 'PUT',
        url: `/AML/${id}/historieprepare`
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};
